import { ColumnDef } from "@tanstack/react-table";
import { PackageProps } from "../../store/actionType";
import ActionButton from "../ActionButton";

export const TableColumns: ColumnDef<PackageProps>[] = [
  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
  {
    accessorFn: (row) => row?.name,
    id: "name",
    cell: (info) => info.getValue(),
    header: () => <span>Package</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.package_type,
    id: "package_type",
    cell: (info) => info.getValue(),
    header: () => <span>Package Type</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.package_order,
    id: "package_order",
    cell: (info) => info.getValue(),
    header: () => <span>Order in Commercial site</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.description,
    id: "description",
    cell: (info) => info.getValue(),
    header: () => <span>Description</span>,
    filterFn: "equalsString",
  },
  {
    accessorFn: (row) => row?.information,
    id: "information",
    header: () => <span>Information</span>,
    filterFn: "equalsString",
    cell: (info) => {
      const value = info.getValue() as string | undefined;
      const text = value ?? "";

      return text.length > 100 ? text.substring(0, 100) + "..." : text;
    },
  },

  {
    id: "action",
    cell: ({ row }) => {
      return (
        <div className="flex justify-center items-center gap-2">
          <ActionButton items={row.original} />
        </div>
      );
    },
    header: () => <span>Actions</span>,
    enableSorting: false,
  },
];
